import FAQs from "../components/faqs"
import PageHeader from "../components/page-header"
import Testimonials from "../components/testimonials"
import { faqs } from "../resources"

import imageAfter from "./images/picture-after.webp"
import imageBefore from "./images/picture-before.webp"
import Plans from "./plans"

const comparisonImages = [imageBefore, imageAfter]
const filteredFaqs = [...faqs.slice(0, 2), ...faqs.slice(3)]

const AntiAging = ({ presetList }) => (
  <div
    sx={{ maxWidth: "100%", mx: "auto", mb: 7 }}
    data-testid="web-portal-plan-selection-anti-aging"
  >
    <PageHeader headline="Wähle ein Produkt aus:" />

    <Plans presetList={presetList} />

    <Testimonials
      headline="Echte Menschen – Echte Erfolge"
      subline="Nach nur 12 Wochen sehen unsere Patient:innen erste sichtbare Erfolge."
      images={comparisonImages}
      labels={["Vorher", "Nachher"]}
      customer={
        <>
          <span sx={{ fontWeight: "bold" }}>Miriam, </span>
          FORMEL SKIN
        </>
      }
      sx={{
        justifyContent: "center",
        textAlign: ["center", "center"],
        gridTemplateRows: [null, "auto"],
        gridTemplateColumns: [null, "310px"],
        gridTemplateAreas: [
          null,
          `
            "header"
            "photos"
            "footer"
          `,
        ],
      }}
    />

    <FAQs items={filteredFaqs} />
  </div>
)

export default AntiAging
